<div class="row shadow-sm rounded-3">
  <!-- Left Section -->
  <div class="col-7 bg-white p-3 border-end">
    <div class="d-flex align-items-center mb-2">
      @if (selectedConsignment) {
        <div class="d-flex align-items-center">
          <img [src]="selectedConsignment.Gallery?.GalleryImgUrl ? selectedConsignment.Gallery?.GalleryImgUrl : 'assets/images/No-Image.png'"
            class="rounded-circle shadow-sm" height="50" width="50" [alt]="'consignmentData.galleryImage' | transloco" />
            <div class="ms-3"
              [routerLink]="selectedConsignment.Gallery?.UserName ? ['/profile', selectedConsignment.Gallery?.UserName] : null"
              style="cursor: pointer;">
              <a href="javascript:void(0);"
                class="text-primary text-decoration-none fs-6 fw-bold text-uppercase">
                {{ selectedConsignment.Gallery?.BusinessName }}
              </a>
              <div class="text-muted small">{{ selectedConsignment.Gallery?.Name }}</div>
            </div>
          </div>
        }
      </div>

      @if (!selectedConsignment.HasGalleryAcceptedProducts) {
        <div class="text-muted fst-italic mb-1">
          {{ 'consignmentData.waitingForGalleryReview' | transloco }}
        </div>
      }

      <hr class="mb-2" />

      <div class="d-flex flex-column justify-content-center align-items-start ">
        @if (selectedConsignment.Gallery?.Email) {
          <div class="d-flex align-items-center mb-2">
            <i class="fa fa-envelope text-muted me-2"></i>
            <div class="fs-6 fw-semibold me-2">{{ 'consignmentData.email' | transloco }}</div>
            <div class="text-muted">{{ selectedConsignment.Gallery?.Email }}</div>
          </div>
        }

        @if (selectedConsignment.Gallery?.PhoneNumber) {
          <div class="d-flex align-items-center mb-2">
            <i class="fa fa-phone text-muted me-2"></i>
            <div class="fs-6 fw-semibold me-2">{{ 'consignmentData.phoneNumber' | transloco }}</div>
            <div class="text-muted">{{ selectedConsignment.Gallery?.PhoneNumber }}</div>
          </div>
        }

        <!-- Dispatch Comments Section -->
        @if (selectedConsignment?.ConsignmentDispatchComment) {
          <div class="mb-2">
            <div class="fs-6 fw-semibold mb-1">
              {{ 'consignmentData.dispatchComments' | transloco }}
            </div>
            <div class="text-muted">
              {{ selectedConsignment.ConsignmentDispatchComment }}
            </div>
          </div>
        }
      </div>
    </div>

    <!-- Right Section -->
    <div class="col-5 bg-white p-3">
      <h5 class="fs-4 fw-bold mb-3">{{ 'consignmentData.consignmentDetails' | transloco }}</h5>
      <div class="mb-2 d-flex align-items-center">
        <div class="fs-6 fw-semibold me-2">{{ 'consignmentData.consignmentName' | transloco }}</div>
        <div class="text-muted">{{ selectedConsignment.Name }}</div>
      </div>
      <div class="mb-2 d-flex align-items-center">
        <div class="fs-6 fw-semibold me-2">{{ 'consignmentData.gallerySalesType' | transloco }}</div>
        <div class="text-muted">{{selectedConsignment.GallerySaleType}}</div>
      </div>
      <div class="mb-2 d-flex align-items-center">
        <div class="fs-6 fw-semibold me-2">{{ 'consignmentData.createdDate' | transloco }}</div>
        <div class="text-muted">{{ selectedConsignment.CreatedDate | date: 'dd/MM/yyyy HH:mm' }}
          @if (isToday(selectedConsignment.CreatedDate)) {
            {{ 'consignmentData.today' | transloco }}
          }
          @if (!isToday(selectedConsignment.CreatedDate)) {
            {{ 'consignmentData.daysAgo' | transloco: { days: dispatchedDaysAgo(selectedConsignment.CreatedDate) } }}
          }
        </div>
      </div>
      <div class="mb-2 d-flex align-items-center">
        <div class="fs-6 fw-semibold me-2">{{ 'consignmentData.consignmentStatus' | transloco }}</div>
        <div class="text-muted">{{ selectedConsignment.ConsignmentStatus}}</div>
      </div>
      <div class="mb-2 d-flex align-items-center">
        <div class="fs-6 fw-semibold me-2">{{ 'consignmentData.commission' | transloco }}</div>
        <div class="text-muted">{{selectedConsignment.Commission}}%</div>
      </div>
      <div class="mb-2 d-flex align-items-center">
        <div class="fs-6 fw-semibold me-2">{{ 'consignmentData.dispatchedDate' | transloco }}</div>
        <div class="text-muted">{{ selectedConsignment.DispatchedTime | date: 'dd/MM/yyyy HH:mm' }}
          @if (isToday(selectedConsignment.DispatchedTime)) {
            {{ 'consignmentData.today' | transloco }}
          }
          @if (!isToday(selectedConsignment.DispatchedTime)) {
            {{ 'consignmentData.daysAgo' | transloco: { days: dispatchedDaysAgo(selectedConsignment.DispatchedTime) } }}
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Gallery Terms History Section -->
  <div class="row shadow-sm rounded-3 mt-3 bg-white p-2">
    <h5 class="fs-4 fw-bold mb-3">{{ 'consignmentData.galleryTermsConditions' | transloco }}</h5>
    <div class="alert alert-info mb-4 rounded-lg shadow-sm">
      <div class="d-flex align-items-center">
        <i class="pi pi-info-circle text-primary me-2"></i>
        <p class="mb-0 text-dark">
          {{ 'consignmentData.termsInfoDescription' | transloco }}
        </p>
      </div>
    </div>

    <!-- Empty Message -->
    @if (!selectedConsignment.GalleryTermsHistory ||
      (!selectedConsignment.GalleryTermsHistory?.PaymentTerms &&
      !selectedConsignment.GalleryTermsHistory?.ReturnPolicy &&
      !selectedConsignment.GalleryTermsHistory?.TermsConditions &&
      !selectedConsignment.GalleryTermsHistory?.GalleryDocuments?.length)) {
      <div class="bg-light rounded-lg shadow-sm p-4 text-center">
        <i class="pi pi-info-circle text-muted mb-3 d-block" style="font-size: 2rem;"></i>
        <p class="mb-0 text-muted">{{ 'consignmentData.noTermsAvailable' | transloco }}</p>
      </div>
    }

    <!-- Payment Terms Section -->
    @if (selectedConsignment.GalleryTermsHistory?.PaymentTerms) {
      <div class="bg-light rounded-lg shadow-sm overflow-hidden mb-3 p-1"
        >
        <div class="bg-white px-3 py-2">
          <h5 class="mb-0 fw-semibold text-dark"><i class="pi pi-credit-card me-2 text-primary"></i>{{ 'consignmentData.paymentTerms' | transloco }}</h5>
        </div>
        <div class="p-4">
          <div class="text-dark" [innerHTML]="selectedConsignment.GalleryTermsHistory?.PaymentTerms || ''"></div>
          <!-- Payment Terms Documents -->
          @if (getDocumentsBySection(1)?.length) {
            <div class="mt-4">
              <div class="row g-2">
                @for (doc of getDocumentsBySection(1); track doc) {
                  <div class="col-12 col-md-4">
                    <div class="bg-white rounded-lg p-3 border">
                      <div class="d-flex justify-content-between mb-2">
                        <div class="flex-grow-1">
                          <h6 class="mb-1 fw-semibold text-dark">
                            @if (doc.DocumentUrl?.includes('.pdf')) {
                              <i class="pi pi-file"></i>
                            }
                            @if (doc.DocumentUrl?.includes('.docx')) {
                              <i class="pi pi-file"></i>
                            }
                            {{ doc.DocumentName | slice:0:25 }}{{ doc.DocumentName.length > 25 ? '...' : ''
                            }}
                          </h6>
                          <small class="text-muted">
                            {{ 'consignmentData.uploaded' | transloco }} {{ selectedConsignment.GalleryTermsHistory?.UpdatedDate |
                            date:'mediumDate' }}
                          </small>
                        </div>
                      </div>
                      <button pButton type="button" class="p-button-outlined w-100" [label]="'consignmentData.viewDocument' | transloco"
                      (click)="viewDocument(doc.DocumentUrl)" [title]="'consignmentData.viewDocumentTitle' | transloco: { name: doc.DocumentName }"></button>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }

    <!-- Return/Refund Policy Section -->
    @if (selectedConsignment.GalleryTermsHistory?.ReturnPolicy) {
      <div class="bg-light rounded-lg shadow-sm overflow-hidden mb-3 p-1"
        >
        <div class="bg-white px-3 py-2">
          <h5 class="mb-0 fw-semibold text-dark"><i class="pi pi-undo me-2 text-warning"></i>{{ 'consignmentData.returnRefundPolicy' | transloco }}</h5>
        </div>
        <div class="p-4">
          <div class="text-dark" [innerHTML]="selectedConsignment.GalleryTermsHistory?.ReturnPolicy || ''"></div>
          <!-- Return Policy Documents -->
          @if (getDocumentsBySection(2)?.length) {
            <div class="mt-4">
              <div class="row g-2">
                @for (doc of getDocumentsBySection(2); track doc) {
                  <div class="col-12 col-md-4">
                    <div class="bg-white rounded-lg p-3 border">
                      <div class="d-flex justify-content-between mb-2">
                        <div class="flex-grow-1">
                          <h6 class="mb-1 fw-semibold text-dark">
                            @if (doc.DocumentUrl?.includes('.pdf')) {
                              <i class="pi pi-file"></i>
                            }
                            @if (doc.DocumentUrl?.includes('.docx')) {
                              <i class="pi pi-file"></i>
                            }
                            {{ doc.DocumentName | slice:0:25 }}{{ doc.DocumentName.length > 25 ? '...' : ''
                            }}
                          </h6>
                          <small class="text-muted">
                            {{ 'consignmentData.uploaded' | transloco }} {{ selectedConsignment.GalleryTermsHistory?.UpdatedDate |
                            date:'mediumDate' }}
                          </small>
                        </div>
                      </div>
                      <button pButton type="button" class="p-button-outlined w-100" [label]="'consignmentData.viewDocument' | transloco"
                      (click)="viewDocument(doc.DocumentUrl)" [title]="'consignmentData.viewDocumentTitle' | transloco: { name: doc.DocumentName }"></button>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }

    <!-- Terms & Conditions Section -->
    @if (selectedConsignment.GalleryTermsHistory?.TermsConditions) {
      <div class="bg-light rounded-lg shadow-sm overflow-hidden mb-3 p-1"
        >
        <div class="bg-white px-3 py-2">
          <h5 class="mb-0 fw-semibold text-dark"><i class="pi pi-file me-2 text-success"></i>{{ 'consignmentData.termsConditions' | transloco }}</h5>
        </div>
        <div class="p-4">
          <div class="text-dark" [innerHTML]="selectedConsignment.GalleryTermsHistory?.TermsConditions || ''"></div>
          <!-- Terms & Conditions Documents -->
          @if (getDocumentsBySection(3)?.length) {
            <div class="mt-4">
              <div class="row g-2">
                @for (doc of getDocumentsBySection(3); track doc) {
                  <div class="col-12 col-md-4">
                    <div class="bg-white rounded-lg p-3 border">
                      <div class="d-flex justify-content-between mb-2">
                        <div class="flex-grow-1">
                          <h6 class="mb-1 fw-semibold text-dark">
                            @if (doc.DocumentUrl?.includes('.pdf')) {
                              <i class="pi pi-file"></i>
                            }
                            @if (doc.DocumentUrl?.includes('.docx')) {
                              <i class="pi pi-file"></i>
                            }
                            {{ doc.DocumentName | slice:0:25 }}{{ doc.DocumentName.length > 25 ? '...' : ''
                            }}
                          </h6>
                          <small class="text-muted">
                            {{ 'consignmentData.uploaded' | transloco }} {{ selectedConsignment.GalleryTermsHistory?.UpdatedDate |
                            date:'mediumDate' }}
                          </small>
                        </div>
                      </div>
                      <button pButton type="button" class="p-button-outlined w-100" [label]="'consignmentData.viewDocument' | transloco"
                      (click)="viewDocument(doc.DocumentUrl)" [title]="'consignmentData.viewDocumentTitle' | transloco: { name: doc.DocumentName }"></button>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }

    <!-- Version and Updated Date -->
    @if (selectedConsignment.GalleryTermsHistory?.Version || selectedConsignment.GalleryTermsHistory?.UpdatedDate) {
      <div class="bg-light rounded-lg shadow-sm p-3"
        >
        <div class="d-flex justify-content-between align-items-center">
          <div class="fs-6 fw-semibold text-dark">
            {{ 'consignmentData.version' | transloco }} {{ selectedConsignment.GalleryTermsHistory?.Version || 'N/A' }}
          </div>
          <div class="text-muted small">
            {{ 'consignmentData.lastUpdated' | transloco }} {{ selectedConsignment.GalleryTermsHistory?.UpdatedDate | date:'mediumDate' }}
          </div>
        </div>
      </div>
    }
  </div>